import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class CloseDealerScheduleSellerValueObject extends ValueObject {
  /**
   * @param {Object}        deps
   * @param {DealerEntity}  deps.dealer
   * @param {Number}        deps.distance
   * @param {Array<Object>} deps.schedule
   * @param {String}        deps.schedule.from
   * @param {String}        deps.schedule.to
   */
}
